"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputMapFindPlaceBase = exports.textBase = exports.buttonNextBase = exports.inputTimeBase = exports.inputSelectBase = exports.inputCheckboxBase = exports.inputRangeBase = exports.infoTextBase = exports.inputNumberBase = exports.inputStringBase = exports.inputRadioNumberBase = exports.inputRadioBase = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const frontendHelper_1 = require("../../services/display/frontendHelper");
// TODO: Make sure to add tests for these default inputs
// Input Radio default params
exports.inputRadioBase = {
    type: 'question',
    inputType: 'radio',
    datatype: 'string',
    columns: 1
};
// Input Radio Number default params
exports.inputRadioNumberBase = {
    type: 'question',
    inputType: 'radioNumber',
    columns: 1,
    sameLine: true
};
// Input String default params
exports.inputStringBase = {
    type: 'question',
    inputType: 'string',
    datatype: 'string'
};
// Input Number default params
exports.inputNumberBase = {
    type: 'question',
    inputType: 'string',
    datatype: 'integer',
    size: 'small',
    inputFilter: (value) => {
        // Remove all non-numeric characters
        return value.replace(/[^0-9]/g, '');
    },
    keyboardInputMode: 'numeric'
};
// InfoText default params
exports.infoTextBase = {
    type: 'text'
};
// InputRange default params
exports.inputRangeBase = {
    type: 'question',
    inputType: 'slider'
};
// Checkbox default params
exports.inputCheckboxBase = {
    type: 'question',
    inputType: 'checkbox',
    datatype: 'string',
    columns: 1
};
// Select default params
exports.inputSelectBase = {
    type: 'question',
    inputType: 'select',
    datatype: 'string'
};
// InputTime default params
exports.inputTimeBase = {
    type: 'question',
    inputType: 'time',
    datatype: 'integer'
};
// Next button default params
exports.buttonNextBase = {
    type: 'button',
    color: 'green',
    hideWhenRefreshing: true,
    // FIXME: Fix import icon
    icon: free_solid_svg_icons_1.faCheckCircle,
    align: 'center',
    action: frontendHelper_1.validateButtonActionWithCompleteSection
};
// Text textarea default params
exports.textBase = {
    type: 'question',
    inputType: 'text',
    datatype: 'text'
};
// Find map place default params
exports.inputMapFindPlaceBase = {
    type: 'question',
    inputType: 'mapFindPlace',
    height: '32rem',
    containsHtml: true,
    autoConfirmIfSingleResult: true,
    placesIcon: {
        url: () => '/dist/images/activities_icons/default_marker.svg',
        size: [70, 70]
    },
    selectedIcon: {
        url: () => '/dist/images/activities_icons/default_selected_marker.svg',
        size: [70, 70]
    },
    defaultCenter: project_config_1.default.mapDefaultCenter,
    refreshGeocodingLabel: (t) => t('customLabel:RefreshGeocodingLabel'),
    showSearchPlaceButton: () => true,
    afterRefreshButtonText: (t) => t('customLabel:GeographyAfterRefresh'),
    validations: (value, _customValue, interview, path) => {
        const geography = surveyHelper.getResponse(interview, path, null);
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: {
                    fr: 'Le positionnement du lieu est requis.',
                    en: 'Positioning of the place is required.'
                }
            },
            {
                validation: geography &&
                    geography.properties.lastAction &&
                    geography.properties.lastAction === 'mapClicked' &&
                    geography.properties.zoom < 15,
                errorMessage: {
                    fr: 'Le positionnement du lieu n\'est pas assez précis. Utilisez le zoom + pour vous rapprocher davantage, puis précisez la localisation en déplaçant l\'icône.',
                    en: 'The positioning of the place is not precise enough. Please use the + zoom and drag the icon marker to confirm the precise location.'
                }
            }
        ];
    }
};
//# sourceMappingURL=defaultInputBase.js.map